import {RepositoryFilterProvider, type Repository} from '@github-ui/filter/providers'
import type {FilterQuery, AnyBlock, MutableFilterBlock, FilterConfig, ARIAFilterSuggestion} from '@github-ui/filter'
import {FilterValueType} from '@github-ui/filter'
import {singleValueFilterTypes} from '../SecurityProductsFilterBar'

/** Org-scoped repository filter - users type "repo-name" instead of "org/repo-name". */
export class SecurityProductsRepositoryFilterProvider extends RepositoryFilterProvider {
  #orgName: string

  constructor(orgName: string) {
    super({filterTypes: singleValueFilterTypes})

    this.#orgName = orgName
  }

  override async getSuggestions(
    filterQuery: FilterQuery,
    filterBlock: AnyBlock | MutableFilterBlock,
    _config: FilterConfig,
    caretIndex?: number | null,
  ) {
    return this.processSuggestions(filterQuery, filterBlock, this.#processSuggestion.bind(this), caretIndex)
  }

  #processSuggestion(repo: Repository, query: string): ARIAFilterSuggestion {
    const {name} = repo

    return this.rankSuggestion(query, {
      type: FilterValueType.Value,
      displayName: name,
      ariaLabel: `${name}, ${this.displayName}`,
      value: name,
      inlineDescription: false,
      icon: this.icon,
    })
  }

  override async fetchSuggestions(
    value: string,
    block: AnyBlock | MutableFilterBlock,
    filterQuery: FilterQuery,
  ): Promise<Repository[] | null> {
    const orgScopedValue = `${this.#orgName}/${value}`
    return super.fetchSuggestions(orgScopedValue, block, filterQuery)
  }

  override async validateFilterValue(
    value: string,
    fetchParams?: URLSearchParams,
    filterQuery?: FilterQuery,
  ): Promise<Repository | Error | null> {
    const orgScopedValue = `${this.#orgName}/${value}`
    return super.validateFilterValue(orgScopedValue, fetchParams, filterQuery)
  }
}
